export const acceptedTemplates = ['maintenance', 'updates_available', 'cycle_fault']
